package com.yogaaicoach.user

import com.yogaaicoach.pages.auth.TokenData
import com.yogaaicoach.pages.auth.TokenDataManager

private external val localStorage: dynamic

private const val userUidStr = "user_uid"
private const val userAccessTokenStr = "user_access_token"
private const val userIdTokenStr = "user_id_token"
private const val userRefreshTokenStr = "user_refresh_token"
private const val userExpirationTimeStr = "user_expiration_time"

actual fun saveUserInfo(uid: String, tokenData: TokenData) {
    localStorage.setItem(userUidStr, uid)
    localStorage.setItem(userAccessTokenStr, tokenData.accessToken)
    localStorage.setItem(userIdTokenStr, tokenData.idToken)
    localStorage.setItem(userRefreshTokenStr, tokenData.refreshToken)
    localStorage.setItem(userExpirationTimeStr, tokenData.expirationTimestampMs.toString())
}

actual fun getUserInfo(): UserInfo? {
    val uid = localStorage.getItem(userUidStr) as String?
    val accessToken = localStorage.getItem(userAccessTokenStr) as String?
    val idToken = localStorage.getItem(userIdTokenStr) as String?
    val refreshToken = localStorage.getItem(userRefreshTokenStr) as String?
    val expirationTimeStr = localStorage.getItem(userExpirationTimeStr) as String?

    if (uid != null && accessToken != null && idToken != null && refreshToken != null && expirationTimeStr != null) {
        return try {
            val expirationTime = expirationTimeStr.toLong()
            val tokenData = TokenDataManager.initialize(accessToken, refreshToken, idToken, expirationTime)
            UserInfo(uid, tokenData)
        } catch (e: Exception) {
            null
        }
    }
    return null
}

actual fun clearUserInfo() {
    localStorage.removeItem(userUidStr)
    localStorage.removeItem(userAccessTokenStr)
    localStorage.removeItem(userIdTokenStr)
    localStorage.removeItem(userRefreshTokenStr)
    localStorage.removeItem(userExpirationTimeStr)
}
